export default __webpack_public_path__ + "static/media/carte.c0e20ff6.jpg";